import { useModal } from '@shared/model/useModal';

export const useOrderModal = () => useModal('order')